export interface IFocusEvent extends Event {
    relatedTarget:EventTarget;
}
